<template>
  <wechat-applyment-wizard :key="wizardKey" mode="shop" :id="applymentId" />
</template>

<script>
import WechatApplymentWizard from "./components/WechatApplymentWizard.vue";

export default {
  name: "WechatApplymentForm",
  components: {
    WechatApplymentWizard,
  },
  computed: {
    applymentId() {
      return this.$route.query.id || "";
    },
    wizardKey() {
      if (this.applymentId) return `edit-${this.applymentId}`;
      return `create-${this.$route.query.store_id || 0}-${this.$route.query._t || ""}`;
    },
  },
};
</script>
